import { createAsyncThunk } from '@reduxjs/toolkit';

import { SecondaryMarketService } from 'api';

import { asyncPayloadCreator } from 'utils';

export const cancelCounteroffer = createAsyncThunk(
	'secondaryMarket/cancelCounteroffer',
	async (id: string, { rejectWithValue }) =>
		asyncPayloadCreator(id, { rejectWithValue }, SecondaryMarketService.cancelCounteroffer),
);
